import {
  Activity,
  Cloud as CloudIcon,
  CreditCard,
  Github,
  Key,
  LayoutDashboard,
  PieChart,
  User as UserIcon,
  Users,
} from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { ROUTES } from '@/config/routes.js';
import { cn } from '@/lib/utils.js';

export const NAV_ITEMS = [
  { to: ROUTES.ADMIN.DASHBOARD, label: 'Dashboard', icon: LayoutDashboard },
  { to: ROUTES.ADMIN.PROFILE, label: 'Profile', icon: UserIcon },
  { to: ROUTES.ADMIN.SUBSCRIPTION, label: 'Subscription', icon: CreditCard },
  { to: ROUTES.ADMIN.API_KEYS, label: 'API Keys', icon: Key },
  { to: ROUTES.ADMIN.REPOSITORIES, label: 'Repositories', icon: Github },
  { to: ROUTES.ADMIN.CLOUD, label: 'Cloud', icon: CloudIcon },
  { to: ROUTES.ADMIN.TEAMS, label: 'Teams', icon: Users },
  { to: ROUTES.ADMIN.ANALYTICS, label: 'Analytics', icon: PieChart },
  { to: ROUTES.ADMIN.EVENTS, label: 'Events', icon: Activity },
];

export function SidebarNav({ onNavigate, collapsed = false }) {
  return (
    <nav aria-label="Primary" className={cn('flex flex-col gap-1 p-2', collapsed && 'items-center')}>
      {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          onClick={onNavigate}
          title={collapsed ? label : undefined}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-3 rounded-md text-sm font-medium transition-colors',
              'hover:bg-accent hover:text-accent-foreground',
              isActive && 'bg-accent text-accent-foreground',
              collapsed ? 'h-10 w-10 justify-center' : 'px-3 py-2',
            )
          }
        >
          <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
          {!collapsed && <span>{label}</span>}
        </NavLink>
      ))}
    </nav>
  );
}
